import { render, staticRenderFns } from "./auto-paper.vue?vue&type=template&id=3d703aa0&scoped=true&"
import script from "./auto-paper.vue?vue&type=script&lang=ts&"
export * from "./auto-paper.vue?vue&type=script&lang=ts&"
import style0 from "./auto-paper.vue?vue&type=style&index=0&id=3d703aa0&lang=scss&scoped=true&"
import style1 from "./auto-paper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d703aa0",
  null
  
)

export default component.exports